import script from "./CourseSubscription.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseSubscription.vue?vue&type=script&setup=true&lang=js"

import "./CourseSubscription.vue?vue&type=style&index=0&id=62f5924c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62f5924c"]])

export default __exports__